<template>
  <div class="pc-competition-series">
    <div class="pc-competition-series-header">
      <h2>竞赛说明信息</h2>
      <div class="pc-button-group">
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <div class="search-tags">
      <p
        class="search-tag"
        :class="item == selectedTag ? 'active' : ''"
        v-for="item in competitionInfoList"
        :key="item.id"
        @click="changeTag(item)"
      >
        {{ item.chinese_info_name }}
      </p>
      <p v-if="isEditting" class="addInfo" @click="addInfo()">添加分类</p>
      <p v-if="isEditting" class="addInfo" @click="saveInfo()">保存分类</p>
      <p v-if="isEditting" class="addInfo" @click="deleteInfo()">删除分类</p>
      <p v-if="isEditting" class="addInfo" @click="changeInfo()">修改分类</p>
    </div>
    <div>
      <EditWithTranslator
        ref="richText"
        :chineseText="competitionInfoDetail.chinese_info_content"
        :englishText="competitionInfoDetail.english_info_content"
        :title="competitionInfoDetail.chinese_info_name"
        :isEditting="isEditting"
      />

      <!-- </div> -->
    </div>

    <el-dialog
      class="designerDialog"
      :title="competitionInfoDetail.chinese_info_name"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="中文名称">
          <el-input
            v-model="competitionInfoDetail.chinese_info_name"
            placeholder="请输入中文名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input
            v-model="competitionInfoDetail.english_info_name"
            placeholder="请输入英文名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="
            isUpdateShow = false;
            cancelRichText();
          "
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(competitionInfoDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import EditWithTranslator from "../../../componentSet/EditWithTranslator.vue";
import {
  getCompetitionInfo_Api,
  createCompetitionInfo_Api,
  updateCompetitionInfo_Api,
  deleteCompetitionInfo_Api,
} from "@/apis/competition.api.js";
export default {
  components: {
    DeleteDialog,
    EditWithTranslator,
  },
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      isUpdateShow: false,
      selectedTag: {},
      titles: [],
      competitionInfoList: [],
      competitionInfoDetail: {
        info_id: null,
        competition_id: null,
        chinese_info_name: "",
        english_info_name: "",
        chinese_info_content: "",
        english_info_content: "",
      },
    };
  },
  created() {
    this.start();
  },
  methods: {
    start() {
      getCompetitionInfo_Api(this.$route.query.id).then((res) => {
        this.competitionInfoList = res.data;
        if (this.competitionInfoList.length != 0) {
          this.selectedTag = this.competitionInfoList[0];
          this.competitionInfoDetail = this.selectedTag;
        }

        console.log(this.competitionInfoList);
      });
    },
    cancelRichText() {
      if (this.competitionInfoDetail.id != null) {
        this.isUpdateShow = false;
      } else {
        this.start();
      }
    },
    changeTag(item) {
      console.log(item);
      this.selectedTag = item;
      this.competitionInfoDetail = item;
    },
    addInfo() {
      this.isUpdateShow = true;
      this.competitionInfoDetail = {
        info_id: null,
      };
      console.log(this.competitionInfoDetail);
    },
    deleteInfo() {
      this.deleteDialogVisible = true;
    },
    changeInfo() {
      this.isUpdateShow = true;
      console.log(this.competitionInfoDetail);
    },
    saveInfo() {
      this.competitionInfoDetail.info_id = this.selectedTag.id;
      this.competitionInfoDetail.chinese_info_content =
        this.$refs.richText.getContent1();
      this.competitionInfoDetail.english_info_content =
        this.$refs.richText.getContent();
      console.log(this.competitionInfoDetail);
      if (this.competitionInfoDetail.chinese_info_content == "") {
        this.$global.error(this, "竞赛中文说明信息必填");
        return;
      }
      if (this.competitionInfoDetail.english_info_content == "") {
        this.$global.error(this, "竞赛英文说明信息必填");
        return;
      }
      updateCompetitionInfo_Api(this.competitionInfoDetail).then((res) => {
        console.log(res);
        this.start();
        this.competitionInfoDetail = {
          info_id: null,
          competition_id: null,
          chinese_info_name: "",
          english_info_name: "",
          chinese_info_content: "",
          english_info_content: "",
        };
      });
    },
    submitBanner() {
      this.isUpdateShow = false;
      this.competitionInfoDetail.competition_id = parseInt(
        this.$route.query.id
      );
      if (this.competitionInfoDetail.id != null) {
        updateCompetitionInfo_Api(this.competitionInfoDetail).then((res) => {
          console.log(111);
        });
      } else {
        createCompetitionInfo_Api(this.competitionInfoDetail).then((res) => {
          this.$global.success(this, "添加成功");
          this.competitionInfoDetail = res.data;
          this.selectedTag = this.competitionInfoDetail;
          this.competitionInfoList.push(this.competitionInfoDetail);

          console.log(222);
        });
      }
    },

    manageSeries() {
      this.isEditting = true;
    },
    save() {
      this.competitionInfoDetail.info_id = this.selectedTag.id;
      this.competitionInfoDetail.chinese_info_content =
        this.$refs.richText.content.chineseText;
      this.competitionInfoDetail.english_info_content =
        this.$refs.richText.content.englishText;
      console.log(this.competitionInfoDetail);
      if (this.competitionInfoDetail.chinese_info_content == "") {
        this.$global.error(this, "竞赛中文说明信息必填");
        return;
      }
      if (this.competitionInfoDetail.english_info_content == "") {
        this.$global.error(this, "竞赛英文说明信息必填");
        return;
      }
      this.isEditting = false;
      updateCompetitionInfo_Api(this.competitionInfoDetail).then((res) => {
        console.log(res);
        this.start();
        this.competitionInfoDetail = {
          info_id: null,
          competition_id: null,
          chinese_info_name: "",
          english_info_name: "",
          chinese_info_content: "",
          english_info_content: "",
        };
        this.$global.success(this, "竞赛信息更新成功");
      });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteConfirm() {
      this.deleteDialogVisible = false;

      deleteCompetitionInfo_Api({ info_id: this.selectedTag.id }).then(
        (res) => {
          this.start();
          this.$global.success(this, "删除成功");
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-competition-series {
  @include box-model;
  .search-tags {
    display: flex;
    margin-top: 20px;
    border-bottom: 1px solid $indexHotLine;
    margin-bottom: 33px;
    .search-tag {
      font-size: 16px;
      line-height: 40px;
      font-weight: 500;
      margin-right: 50px;
      cursor: pointer;
    }
    .addInfo {
      width: 90px;
      height: 30px;
      margin-right: 20px;
      line-height: 30px;
      cursor: pointer;
      text-align: center;
      color: rgb(104, 100, 100);
      border: 1px #5470c6 dashed;
    }
    .search-tag1 {
      font-size: 15px;
      line-height: 40px;
      font-weight: 500;
      margin-right: 50px;
      color: rgb(126, 121, 121);
      cursor: pointer;
    }
    .active {
      color: $timeBtn;
      border-bottom: 3px solid $timeBtn;
    }
  }
  .pc-competition-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
    }
    .pc-btn {
      @include manage-button;
    }
  }
  /deep/ .el-dialog__footer {
    .dialog-footer-button-one {
      @include manage-button;
      background: $test;
      color: $blueBtna;
    }
    .dialog-footer-button-second {
      @include manage-button;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionRichText.vue